import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '../tooltip/Tooltip.jsx';
import IconMenu from '../icon-menu/IconMenu.jsx';

import s from './PoiHeader.module.scss';

const PoiHeader = props => (
    <div className={s.header}>
        <div className={classNames('icon-location', s.poiIcon)} />
        <div className={s.title}>{props.isNew ? 'New Poi' : `POI ${props.poi.id || ''}`}</div>
        {props.isPointPoi && (
            <button className={classNames('icon-move-location', s.headerIcons, s.moveLocationIcon)} onClick={props.onMovePoi} type="button">
                <Tooltip arrowPosition="right" text="Move POI" />
            </button>
        )}
        {!props.isDisabled && !props.isNew && <IconMenu isV5={props.isV5} options={props.iconMenuOptions} />}
        <button className={classNames('icon-close', s.headerIcons, s.closeIcon)} onClick={props.onClose} type="button">
            <Tooltip arrowPosition="right" text="Close POI" />
        </button>
    </div>
);

PoiHeader.propTypes = {
    poi: PropTypes.object,
    iconMenuOptions: PropTypes.arrayOf(PropTypes.object),
    isV5: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isNew: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    isPointPoi: PropTypes.bool,
    onMovePoi: PropTypes.func,
};

PoiHeader.defaultProps = {
    poi: {},
    iconMenuOptions: [],
    isV5: true,
    isNew: true,
    isDisabled: true,
    isPointPoi: false,
    onMovePoi: () => {},
};

export default PoiHeader;
